import { assertNever } from '@framework/engine';
import { t } from '@framework/i18n';
import { IconWrapper } from '@framework/ui';
import {
  MdInfoOutline,
  MdOutlineNotifications,
  MdWarning,
} from 'react-icons/md';
import styled from 'styled-components';
import { NotificationType } from '../NotificationTypes';

const TypeIcon = styled.span`
  max-height: 14px;
  line-height: 14px;
  position: relative;
  margin-right: 25px;
  .anticon {
    font-size: 1.4em;
    line-height: 14px;
    position: absolute;
  }

  .type-info-icon {
    color: #096dd9;
  }
  .type-warning-icon {
    color: #d46b08;
  }
  .type-notifica-icon {
    color: #17324d;
    opacity: 0.75;
  }
`;

function getTypeIcon(type?: NotificationType) {
  if (!type) return null;
  switch (type) {
    case NotificationType.INFO:
      return {
        children: (
          <MdInfoOutline aria-hidden="true" className="type-info-icon" />
        ),
      };
    case NotificationType.WARNING:
      return {
        children: (
          <MdWarning aria-hidden="true" className="type-warning-icon" />
        ),
        title: t('notification-type-icon.warning', 'Attenzione'),
      };
    case NotificationType.NOTIFICA:
      return {
        children: (
          <MdOutlineNotifications
            aria-hidden="true"
            className="type-notifica-icon"
          />
        ),
      };
    default:
      assertNever(type);
  }
}

interface NotificationIconTypeProps {
  type?: NotificationType;
}

/**
 * Icona del tipo di notifica
 */
export function NotificationIconType(props: NotificationIconTypeProps) {
  const { type } = props;
  return (
    <TypeIcon>
      <IconWrapper {...getTypeIcon(type)} />
    </TypeIcon>
  );
}
